import PropTypes from 'prop-types';

export default function ConfirmToast({
    message,
    onDecision,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
}) {
    const handleConfirmar = () => {
        onDecision(true);
    };

    const handleCancelar = () => {
        onDecision(false);
    };

    return (
        <div>
            <p style={{ marginBottom: '8px' }}>{message}</p>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={handleConfirmar}
                >
                    {confirmText}
                </button>
                <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={handleCancelar}
                >
                    {cancelText}
                </button>
            </div>
        </div>
    );
}

ConfirmToast.propTypes = {
    message: PropTypes.string.isRequired,
    onDecision: PropTypes.func.isRequired,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
};
